//importando o client pra ser utilizado
import {clientRestAPI} from "../clientRestAPI/clientRestAPI";
import {getContribuinteHomeAutenticado, getUsuarioAutenticado} from "../routes/auth";
import {toast} from "react-toastify";

//definindo a rota a ser acrescentada na rota base definida no client
const url = "/escrituracao-exercicio";

const escrituracaoExercicioDefault = {
  isEncerrado: false,
  isRevisado: false
}

const escrituracaoExercicioModel = {
  //definindo o estado inicial da aplicação
  state: {
    escrituracaoExercicio: escrituracaoExercicioDefault,
  },

  //definindo todos os reducers
  reducers: {
    fetchEscrituracaoExercicioFulfiled: (state, payload) => {
      return {
        ...state,
        escrituracaoExercicio: payload.data || payload,
      };
    },

    encerrarReabrirFulfilled(state, payload) {
      toast.success("Operação realizada com sucesso!");
      return {
        ...state,
        escrituracaoExercicio: payload.data || payload,
        loading: false,
      };
    },

    encerrarReabrirRejected: (state, payload) => {
      toast.error("Erro ao realizar operação!");
      return {
        ...state,
        loading: false,
      }
    }
  },

  //definindo os effects
  effects: dispatch => ({

    fetchEscrituracaoExercicio(anoExercicio) {
      const ano = anoExercicio.value;
      const idContribuinte = getContribuinteHomeAutenticado().id;

      return clientRestAPI.get(`${url}/${idContribuinte}/${ano}`)
        .then(res => {
          dispatch.escrituracaoExercicioModel.fetchEscrituracaoExercicioFulfiled(res.data)
        })
    },

    fetchEscrituracaoExercicioEncerrarOuReabrir(anoExercicio, _, isEncerramento) {
      const dadosEncerramento = {
        contribuinte: getContribuinteHomeAutenticado(),
        usuario: getUsuarioAutenticado(),
        ano: anoExercicio
      };

      const newUrl = isEncerramento ? `${url}/encerrar` : `${url}/reabrir`;
      return clientRestAPI.post(`${newUrl}`, dadosEncerramento)
        .then(res => {
          dispatch.escrituracaoExercicioModel.encerrarReabrirFulfilled(res.data);
        }).catch(err => {
          dispatch.escrituracaoExercicioModel.encerrarReabrirRejected(err)
        });
    },

    // fetchIsEncerrado(anoExercicio) {
    //   const ano = anoExercicio.value;
    //   const idContribuinte = getContribuinteHomeAutenticado().id;
    //
    //   return clientRestAPI.get(`${url}/is-encerrado/${idContribuinte}/${ano}`)
    //     .then(res => {
    //       dispatch.escrituracaoExercicioModel.fetchIsEncerradoFulfiled(res.data)
    //     })
    // }
  })
}


export default escrituracaoExercicioModel;
